import React from "react";

import Modal from "../../common/Modal";
import styles from "../styles.module.scss";

interface Props {
  visible: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  /** Footer buttons; omitted when the body carries its own (e.g. the address steps). */
  actions?: React.ReactNode;
}

/** Shared shell for the activation task modals: title, optional subtitle, body, footer. */
const ActivationTaskModal: React.FC<Props> = ({
  visible,
  onClose,
  title,
  subtitle,
  children,
  actions,
}) => (
  <Modal
    visible={visible}
    onCancel={onClose}
    customModalClassName={styles.taskModal}>
    <div className={styles.tmHead}>
      <h3>{title}</h3>
      {subtitle && <span>{subtitle}</span>}
    </div>
    <div className={styles.tmBody}>{children}</div>
    {actions && <div className={styles.tmActions}>{actions}</div>}
  </Modal>
);

export default ActivationTaskModal;
